<template>
  <div class="promotionVoucher" v-if="currentBetSlipState<=1 || isActive">
    <v-checkbox hide-details v-model="isActive" :id="betId" :disabled="disabled" @change="toggleSelected" >
<!--      :label="(voucher.Description || voucher.description) + ': ' + currencySymbol + voucher.CurrentAmount"-->
      <template v-slot:label  >
<!--        <span id="checkboxLabel">{{(voucher.Description || voucher.description) + '::: ' + currencySymbol + voucher.CurrentAmount}}</span>-->
        <div class="checkboxLabel" v-html="$t('Betslip.voucher' + (voucher.DiscountPercentage === null ? '.SO' : '') +'.label',
        {currencySymbol, name:voucher.Description || voucher.description, amount:voucher.CurrentAmount, SOinfo: soInfo, exp: parseDateTime(voucher.ExpiryDate) })"></div>
      </template>
    </v-checkbox>

    <!--
    <div class="voucherData" v-if="isActive && (voucher.MinStake || voucher.MaxStake)">
      <span class="voucherMinStake" v-if="voucher.MinStake"><span>{{$t('Betslip.voucher.minStake')}}: </span>{{currencySymbol}}{{voucher.MinStake}}; </span>
      <span class="voucherMaxStake" v-if="voucher.MaxStake"><span>{{$t('Betslip.voucher.maxStake')}}: </span>{{currencySymbol}}{{voucher.MaxStake}};</span>
    </div>
    -->

<!--    voucher: {{voucher}}<br>-->
<!--    voucherIdExt: {{voucherIdExt}}<br>-->
<!--        appliedVoucher: {{appliedVoucher}}<br>-->
    <!--    isActive: {{isActive}}<br>-->
    <!--    isAppliedHere: {{isAppliedHere}}<br>-->
    <!--    isAppliedToOther: {{isAppliedToOther}}<br>-->
  </div>
</template>

<script>
// import Vue from 'vue'
import store from '@/store'
import config from '@/config'
import moment from 'moment'

export default {
  name: 'promotionVoucher',
  props: ['betId', 'tab', 'voucher', 'currentBetSlipState', 'index'],
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
    currencySymbol () {
      return config.app.CURRENCY
    },
    appliedVoucher () {
      return store.getters['sbBetslipState/appliedVoucher'](this.tab)
    },
    voucherIdExt () {
      return this.voucher.IDMMPRVoucher + '|' + this.betId
    },
    isActive: {
      get: function () {
        let getVal = this.appliedVoucher && this.appliedVoucher.isActive && this.appliedVoucher.id === this.voucherIdExt
        // console.log('isActive get:', this.betId, getVal)
        return getVal
      },
      set: function (v) {
        // console.log('isActive set:', this.betId, v)
        return v
      }
    },
    isDeactivatedByUser () {
      return this.appliedVoucher && this.appliedVoucher.id === this.voucherIdExt && this.appliedVoucher.isActive === 0
    },
    // isAppliedHere () {
    //   return this.voucher.appliedTo && this.voucher.appliedTo === this.betId
    // },
    // isAppliedToOther () {
    //   return this.voucher.appliedTo && this.voucher.appliedTo !== this.betId && this.voucher.appliedTo
    // },
    disabled () {
      // return !!this.isAppliedToOther
      return this.currentBetSlipState > 0
      // return false
    },
    autoApply1stVoucherToBet () {
      return store.getters['sbBetslipState/autoApply1stVoucherToBet']
    },
    voucherDateFormat () {
      return store.getters['sbBetslipState/voucherDateFormat']
    },
    soInfo () {
      let soInfo = this.voucher && this.voucher.CustomerNotes
      let regExAlphaNumeric = /^[a-zA-Z0-9]$/
      if (soInfo && regExAlphaNumeric.test(soInfo.slice(-1))) {
        soInfo += '.'
      }
      return soInfo
    }
  },

  methods: {
    toggleSelected (v) {
      v = v || true
      // console.log('toggleSelected:', v, this.betId, 'this.voucher.appliedTo:', this.voucher.appliedTo)
      let data = {voucher: this.voucher, betId: this.betId, tab: this.tab, caller: v}
      store.dispatch('sbBetslipState/applyPromotionVoucher', data)
      //
      if (v !== -1) {
        this.$emit('dismissError', this.betId, false)
      }
    },
    parseDateTime (dateTime) {
      let dateFormat = this.voucherDateFormat || 'MM/DD/YYYY HH:mm A'
      return moment.utc(dateTime).format(dateFormat)
    }
  },

  created () {
    // console.log('Voucher created:', this.betId, ':', this.voucher.IDMMPRVoucher)
    // if (this.voucher) {
    //   this.voucher.MinStake = 10
    //   this.voucher.MaxStake = 50
    // }
  },

  mounted () {
    // console.log('Voucher mounted:', this.betId, ':', this.voucher.IDMMPRVoucher)
    if (this.voucher && this.appliedVoucher && this.appliedVoucher.isActive === false &&
      this.appliedVoucher.betId === this.betId &&
      this.appliedVoucher.voucher && this.appliedVoucher.voucher.IDMMPRVoucher === this.voucher.IDMMPRVoucher) {
      store.commit('sbBetslipState/reactivateVoucherDestroyed', {betId: this.betId, voucherId: this.voucher.IDMMPRVoucher})
    }
  },

  watch: {
    autoApply1stVoucherToBet: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('watch autoApply1stVoucherToBet for', this.betId, ':', oldVal, '=>', newVal)
        if (this.index === 0 && newVal === this.betId) {
          if (!this.isActive && !this.isDeactivatedByUser) {
            this.toggleSelected(-1)
          }
          store.commit('sbBetslipState/setAutoApply1stVoucherToBet', null)
        }
      }
    }
  },

  destroyed () {
    // console.log('Voucher Distroyed:', this.betId, ':', this.voucher.IDMMPRVoucher)
    store.commit('sbBetslipState/deactivateVoucherOnDestroy', {betId: this.betId, voucherId: this.voucher.IDMMPRVoucher})
  }
}
</script>

<style lang="stylus" scoped>
.promotionVoucher
  color: #000
  background-color: #fcc157
  border-radius: 4px
  >>>.v-input
    margin-top: 6px
    padding-left: 4px;
    .v-input__control
      /*height: 28px;*/
      overflow-y: hidden;
      min-height: 24px;
      margin-bottom: 4px;
      .v-label
        color: #6c6c6c
  >>>.v-input.v-input--is-label-active
    .v-label
      color: #000
  .voucherData
    margin-left: 37px;
    margin-top: -7px;
    padding-bottom: 2px;
  .checkboxLabel
    /*width: 280px;*/
    /*white-space: nowrap;*/
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
    font-size: 12px;

</style>



// WEBPACK FOOTER //
// src/components/sports/betslipV2/promotionVouchers/voucher.vue